import { Button, ButtonsGroup, Footer, Heading, PageHeader } from "@/components/atoms";
import { ContactsCard, DateAndTimeCard, ExtraServicesCard, KeysCard, NotesCard, OrderServiceCard, PropertyAddressCard, VirtualStagingFurnitureCard } from "../Order/Cards";
import { FC, memo } from "react";
import { NATURAL } from "@/theme";
import { ORDERSERVICE_TYPE } from "@/types";
import { OrderWorkerProps } from "./OrderWorker.interface";

const OrderWorker: FC<OrderWorkerProps> = ({ 
    addressString,
    appointmentDate,
    appointmentDuration,
    appointmentTime,
    contacts,
    contactVendorDirectly,
    doorNumber,
    flat,
    furnitureNames,
    imageMotionRequested,
    isAdmin,
    keyNotes,
    keys,
    keysTime,
    keysTimeOption,
    keysWith,
    keysWithDetail,
    notes,
    notifyViaSMS,
    onAddFurnitures,
    onAddNote,
    onNavigateToAdmin,
    onNavigateToCustomer,
    onSendToClient,
    onUploadFiles,
    offeredServices,
    orderDetails,
    owner,
    sentToClient,
    services,
    videoMotionRequested,
    virtualStagingRequested
}) => {
    const accordionState = 'open';

    const orderService = orderDetails.services.find((item) => item.type === ORDERSERVICE_TYPE.VIRTUAL_STAGING);
    const orderServiceId = orderService?.orderServiceId || '';
    furnitureNames && (furnitureNames.value = orderService?.externalLink || '');

    const handleDownloadFiles = () => {
      console.log('nope')
    }

    // TODO make styled div
  return (<div style={{paddingBottom: '100px' }}>  
          <PageHeader>
              <Heading scale="h1" fontColor={NATURAL.K}>{orderDetails.description}</Heading>
              { isAdmin && <ButtonsGroup>
                <Button onClick={onNavigateToAdmin}>Admin View</Button>
                <Button onClick={onNavigateToCustomer}>Customer View</Button>
              </ButtonsGroup> }
          </PageHeader>

        { orderDetails.isVirtual && <VirtualStagingFurnitureCard
          accordionState={accordionState}
          furnitureNames={furnitureNames}
          onAddFurnitures={onAddFurnitures}
          orderServiceId={orderServiceId}
          isReadOnly={true}
          />}

        { !orderDetails.isVirtual &&  <DateAndTimeCard
            accordionState={accordionState}
            appointmentDate={appointmentDate}
            appointmentTime={appointmentTime}
            appointmentDuration={appointmentDuration}
            contactVendorDirectly={contactVendorDirectly}
            notifyViaSMS={notifyViaSMS} 
            isReadOnly={true}
        /> }

        { !orderDetails.isVirtual &&  <PropertyAddressCard
            accordionState={accordionState}
            addressString={addressString}
            flat={flat}
            doorNumber={doorNumber}
            isReadOnly={true}
            /> }

        { !orderDetails.isVirtual && <KeysCard
                accordionState={accordionState}
                isReadOnly={true}
                keys={keys}
                keysTime={keysTime}
                keysTimeOption={keysTimeOption}
                keysWith={keysWith}
                keysWithDetail={keysWithDetail}
                keyNotes={keyNotes}
                /> }
        
            <ContactsCard
                accordionState={accordionState}
                contacts={contacts}
                isAdmin={isAdmin}
                isReadOnly={true}
                />
            <NotesCard
                accordionState={accordionState}
                isReadOnly={true}
                notes={notes}
                onAddNote={onAddNote}
                owner={owner}
            />
            <OrderServiceCard
                isAdmin={isAdmin}
                isWorker={true}
                logoUrl={''}
                offeredServices={offeredServices}
                onDownloadFiles={handleDownloadFiles}
                onUploadFiles={onUploadFiles}
                services={services}
              />
                          
                          
            <ExtraServicesCard 
                accordionState={accordionState}
                imageMotionRequested={imageMotionRequested}
                isReadOnly={true}
                videoMotionRequested={videoMotionRequested}
                virtualStagingRequested={virtualStagingRequested}
                />
            
    <Footer>
      <ButtonsGroup fullWidth>
        {!sentToClient && <Button onClick={onSendToClient}>Send to Client</Button> }
      </ButtonsGroup>
    </Footer>
            </div>);
}

export default memo(OrderWorker);